import {updateField} from 'vuex-map-fields';
import {ADD_CREDENTIAL, UPDATE_CREDENTIAL} from "./types";

export default {
    updateField,

    [ADD_CREDENTIAL] (state, payload) {
        const credentialType = state.credentialTypes.find(o => o.type === state.credentialTypeName);

        if (undefined === credentialType) {
            throw new Error('Credential type not found, adding credential failed.');
        }

        if (credentialType.multiple === false && payload.active === true) {
            for (let credential of credentialType.credentials) {
                credential.active = false;
            }
        }

        credentialType.credentials.push(payload);
    },

    [UPDATE_CREDENTIAL] (state, [uuid, payload]) {
        const credentialType = state.credentialTypes.find(o => o.type === state.credentialTypeName);

        if (undefined === credentialType) {
            throw new Error('Credential type not found, adding credential failed.');
        }

        credentialType.credentials = credentialType.credentials.map(credential => {
            if (credential.uuid === uuid) {
                credential = {...credential, ...payload};
            } else if (credentialType.multiple === false && payload.active === true) {
                credential = {...credential, active: false};
            }

            return credential;
        })
    },
};
